/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, Backbone */

_.namespace(`Backbone.widgets`, function(ns) {
  "use strict";

  ns.Notification = Backbone.TemplateView.extend({
    templates: {
      base: `<div class="notification-wrapper">` +
                `    <span class="notification-icon">` +
                `        <div class="icon <%- d.type %>"></div>` +
                `    </span>` +
                `    <span class="notification-text">` +
                `        <div class="notification-text-body"><%- d.body %></div>` +
                `    </span>` +
                `</div>`,
    },

    render() {
      this.render_base_template(this.options);
      this.show();
    },

    handle_close() {
      this.$(`.notification-wrapper`)
        .addClass(`close`)
        .on(`transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd`, _.bind(function() {
          this.remove();
        }, this));
    },

    show() {
      var $wrapper = this.$(`.notification-wrapper`);
      if (this.options.type === `error`) {
        $wrapper.addClass(`error`);
      }
      // css opacity and transform are needed, they force the browser to
      // load the attributes so that the transition will be performed properly
      $wrapper.css(`opacity`);
      $wrapper.css(`transform`);
      $wrapper.addClass(`show`);
    },
  });

});

}.call(window));